import { isProd, isStaging } from '~utils/env';

export enum GTMEvent {
  MY_INSIFY_LOGIN = 'my-insify-login',
}

type UseTagManagerMethods = {
  sendEvent: (event: GTMEvent, payload?: Record<string, string>) => void;
};

export function useTagManager(): UseTagManagerMethods {
  function sendEvent(event: GTMEvent, payload?: Record<string, string>) {
    if ((isProd || isStaging) && typeof window !== undefined) {
      window.dataLayer?.push({ event, ...payload } as any);
    }
  }
  return {
    sendEvent,
  };
}
